var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('TopMenu',{ref:"topMenu"}),_c('Alert'),_c('SideMenu',{ref:"sideMenu",class:{
      hideSide: !_vm.sideActive,
      districtSelected: _vm.districtSelected,
    }}),_c('Map',{ref:"map"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }